import {
  OperacaoOfertaPrimariaCriarLiquidarRequest,
  OperacaoOfertaPrimariaInformacoesBancariasRequest,
  OperacaoOfertaPrimariaRequest,
  OperacaoOfertaPrimariaResponse,
  TipoLiquidacao,
} from 'common/genericTypes';
import { OperacaoState } from 'store/modules/operacoes/registro';

interface InvestidorLiquidacaoInfo {
  id: string;
  quantidade: number;
  cpfCnpj: string;
  razaoSocial: string;
  contaDeposito: string;
  valorTotal: number;
  comprovanteId?: string;
}

interface LiquidacaoInfo {
  cpfCnpjCustodiante?: string;
  razaoSocialCustodiante?: string;
  quantidade: number;
  valorTotal: number;
  investidores: Array<InvestidorLiquidacaoInfo>;
}

interface InvestidorGroup {
  [key: string]: InvestidorLiquidacaoInfo;
}

export interface CustodianteGroup {
  [key: string]: LiquidacaoInfo;
}

export default class OperacaoParser {
  static stateToOperacaoOfertaPrimariaRequest(operacao: OperacaoState): OperacaoOfertaPrimariaRequest {
    return {
      investidores:
        operacao.ofertaPrimaria?.investidores.map((x) => ({
          investidorId: x.investidorId,
          quantidade: x.quantidade,
          precoUnitario: x.precoUnitario,
        })) ?? [],
      informacoesBancarias:
        operacao.ofertaPrimaria?.informacoesBancarias.map((x) => {
          return {
            razaoSocialBanco: x.razaoSocialBanco,
            agenciaBanco: x.agenciaBanco,
            contaBanco: x.contaBanco,
            ispbBanco: x.ispbBanco,
          } as OperacaoOfertaPrimariaInformacoesBancariasRequest;
        }) ?? [],
    };
  }


  static stateToOperacaoOfertaPrimariaRaCriar_LiquidarRequest(operacao: OperacaoState, tipoLiquidacao: TipoLiquidacao): OperacaoOfertaPrimariaCriarLiquidarRequest {
    return {
      investidores:
        operacao.ofertaPrimaria?.investidores.map((x) => ({
          investidorId: x.investidorId,
          quantidade: x.quantidade,
          precoUnitario: x.precoUnitario,
        })) ?? [],
      dataAgendamento: operacao.dataAgendamento, 
      informacoesBancarias:
        operacao.ofertaPrimaria?.informacoesBancarias.map((x) => {
          return {
            razaoSocialBanco: x.razaoSocialBanco,
            agenciaBanco: x.agenciaBanco,
            contaBanco: x.contaBanco,
            ispbBanco: x.ispbBanco,
          } as OperacaoOfertaPrimariaInformacoesBancariasRequest;
        }) ?? [],
      instrumentoFinanceiroGuid: operacao.instrumentoFinanceiroId ?? "",
      solicitarLiquidacao: {
        tipoLiquidacao: tipoLiquidacao,
        precoUnitario: operacao.criteriosRemuneracao?.valorNominalUnitarioEmissao ?? 0
      }
    };
  }



  static ofertaPrimariaResponseToCustodianteGroup(
    precoUnitarioLiquidacao: number,
    ofertasPrimarias: Array<OperacaoOfertaPrimariaResponse>
  ) {
    return ofertasPrimarias.reduce<CustodianteGroup>((group, operacao) => {
      const custodianteId = operacao.custodiante.id;
      const investidorInfos = operacao.ofertaPrimaria.investidores.map(
        (_) =>
        ({
          id: _.investidorId,
          quantidade: _.quantidade,
          cpfCnpj: _.cpfCnpj,
          razaoSocial: _.razaoSocial,
          contaDeposito: _.contaDeposito,
          valorTotal: _.quantidade * precoUnitarioLiquidacao,
          comprovanteId: _.comprovanteId,
        } as InvestidorLiquidacaoInfo)
      );
      if (group[custodianteId]) {
        let groupedInvestidores: InvestidorLiquidacaoInfo[] = [];
        group[custodianteId].investidores.concat(investidorInfos).reduce<InvestidorGroup>((acc, curr) => {
          if (!acc[curr.id]) {
            acc[curr.id] = curr;
            groupedInvestidores.push(acc[curr.id]);
          } else {
            acc[curr.id].quantidade += curr.quantidade;
            acc[curr.id].valorTotal += curr.valorTotal;
          }
          return acc;
        }, {});
        group[custodianteId].investidores = groupedInvestidores;
      } else {
        const liquidacaoInfo: LiquidacaoInfo = { investidores: investidorInfos, quantidade: 0, valorTotal: 0 };
        group[custodianteId] = liquidacaoInfo;
      }
      group[custodianteId].cpfCnpjCustodiante = operacao.custodiante.cnpj ?? '';
      group[custodianteId].razaoSocialCustodiante = operacao.custodiante.razaoSocial;
      group[custodianteId].quantidade = group[custodianteId].investidores.reduce(
        (acc, curr) => acc + curr.quantidade,
        0
      );
      group[custodianteId].valorTotal = group[custodianteId].investidores.reduce(
        (acc, curr) => acc + curr.valorTotal,
        0
      );
      return group;
    }, {});
  }
}
